import React from 'react';

import { render } from 'react-dom';
import { IoClose } from 'react-icons/io5';
import * as cn from 'classnames';

import { Text, Button } from 'modules/common';

import { renderIconType, renderColors } from './constants';

const toastUniqueID = 'geek-toast-marker';

const ToastMarker = (props) => <div id={toastUniqueID} {...props} />;

let toastTimeout = null;

const wait = (t) => new Promise((r) => setTimeout(r, t));

const toast = async (content, options = {}) => {
  let alertRef = null;
  const opt = {
    timeout: 4000,
    title: false,
    divId: 'toast-override',
    position: 'bottom-center',
    widthClassName: 'w-72',
    type: 'default',
    withTimer: false,
    withLeading: true,
    leadingItem: false,
    withClose: true,
    withButton: false,
    buttonProps: {},
    className: 'bottom-ds-40',
    ...options,
    content,
  };

  const isInline = !!document.getElementById(opt.divId);
  const rootElement =
    document.getElementById(opt.divId) ||
    document.getElementById(toastUniqueID);
  if (!rootElement) {
    alert('Alert Marker not found!'); // eslint-disable-line
    return;
  }
  const close = async () => {
    if (alertRef) {
      try {
        // await wait(450);
        alertRef.className = alertRef.className.replace(
          'toast-entrance-ds',
          'toast-exit-ds'
        );
        await wait(450);
      } catch (error) {
        // do nothing...
      }
    }

    document.body.className = '';
    render(<ToastMarker />, rootElement);
  };
  close();
  await wait(5);
  const renderContent = () => {
    if (typeof opt.content === 'function') return opt.content(close);
    return opt.content;
  };

  const renderToast = () => (
    <div
      className={cn(
        'h-full rounded',
        renderColors?.[opt?.type]?.background,
        renderColors?.[opt?.type]?.text
      )}
    >
      <div
        className={cn('flex items-center relative p-ds-12 space-x-3 rounded')}
      >
        {Boolean(opt?.withLeading) && (
          <div className="flex-shrink-0">
            {opt?.leadingItem ||
              (renderIconType[opt?.type] && (
                <svg
                  className={cn('h-5 w-5', renderColors?.[opt?.type]?.icon)}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  {renderIconType[opt?.type]}
                </svg>
              ))}
          </div>
        )}

        <Text type="caption" weight="semibold" className="flex-1">
          {Boolean(opt.content) && renderContent()}
        </Text>

        {(opt?.withClose || opt?.withButton) && (
          <div className="flex gap-ds-8 items-center">
            {opt?.withButton && (
              <Button
                label="Button"
                className="ds-btn ds-xs"
                {...opt?.buttonProps}
              />
            )}

            {opt?.withClose && (
              <span
                role="presentation"
                className="cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  close();
                }}
              >
                <IoClose className="h-4 w-4" />
              </span>
            )}
          </div>
        )}
      </div>

      {/* <Loader
        type={opt?.type}
        timer={opt?.timeout}
        withTimer={opt?.withTimer}
      /> */}
    </div>
  );

  if (opt?.withTimer) {
    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(() => {
      close();
    }, opt.timeout);
  }

  if (isInline) {
    render(renderToast(), rootElement);
    return;
  }

  render(
    <div
      className={`z-50 fixed m-h-20 ${opt?.position} ${opt?.widthClassName} ${opt?.className}`}
    >
      <div
        // eslint-disable-next-line no-return-assign
        ref={(r) => (alertRef = r)}
        className="shadow-tooltip h-full w-full rounded overflow-hidden toast-entrance-ds"
      >
        {renderToast()}
      </div>
    </div>,
    rootElement
  );
};

export default ToastMarker;

export const toastDefault = (content, options) =>
  toast(content, {
    ...options,
    type: 'default',
  });

export const toastSuccess = (content, options) =>
  toast(content, {
    ...options,
    type: 'success',
  });

export const toastError = (content, options) =>
  toast(content, {
    ...options,
    type: 'danger',
  });

export const toastWarning = (content, options) =>
  toast(content, {
    ...options,
    type: 'warning',
  });
